import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import { NavLink } from "react-router-dom";
import gql from "graphql-tag";

import { ApolloClient } from 'apollo-client';
import { Query } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

import Select from 'react-select';
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";


const restLink_cloud = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'  
});
const client_cloud = new ApolloClient({
  link: restLink_cloud,
  cache: new InMemoryCache(),
});



const CREATE_COMMSUBCLIENT_HAS_ACCOUNT = gql`
  mutation createCommSubclientHasAccount($subclient_id: Int!, $account_id: Int!){
    createCommSubclientHasAccount(subclient_id:$subclient_id, account_id: $account_id) {
      id
    }
  }
`;

const DELETE_COMMSUBCLIENT_HAS_ACCOUNT = gql`
mutation deleteCommSubclientHasAccount($subclient_id: Int!, $account_id: Int!){
  deleteCommSubclientHasAccount(subclient_id:$subclient_id, account_id: $account_id) {
    id
  }
}
`;
const GET_COMMSUBCLIENT_HAS_ACCOUNT = gql`
  query commSubclientHasAccount_collection($account_id: Int!){
    commSubclientHasAccount_collection(account_id: $account_id) {
      subclientsHasAccount{
        id
        subclient{
          value:id
          label:title
        }
      }
    }
  }
`;

const GET_COMMSUBCLIENT = gql`
{
  commSubclient_collection{
    subclients{
      value:id
      label:title
    }
  }
}
`;



const CREATE_COMMCLIENTGROUP_HAS_ACCOUNT = gql`
  mutation createCommClientGroupHasAccount($clientGroup_id: Int!, $account_id: Int!){
    createCommClientGroupHasAccount(clientGroup_id:$clientGroup_id, account_id: $account_id) {
      id
    }
  }
`;

const DELETE_COMMCLIENTGROUP_HAS_ACCOUNT = gql`
mutation deleteCommClientGroupHasAccount($clientGroup_id: Int!, $account_id: Int!){
  deleteCommClientGroupHasAccount(clientGroup_id:$clientGroup_id, account_id: $account_id) {
    id
  }
}
`;
const GET_COMMCLIENTGROUP_HAS_ACCOUNT = gql`
  query commClientGroupHasAccount_collection($account_id: Int!){
    commClientGroupHasAccount_collection(account_id: $account_id) {
      clientGroupsHasAccount{
        id
        clientGroup{
          value:id
          label:title
        }
      }
    }
  }
`;

const GET_COMMCLIENTGROUP = gql`
{
  commClientGroup_collection{
    clientGroups{
      value:id
      label:title
    }
  }
}
`;




class CommClientGroupHasAccount extends Component {

  controllerItens = [];
  urlBack;

  constructor() {
    super();
     this.state = {
       defaultOptions : [],
    }

  }

  
  onChange = (inputValue, action ) => {
    
    // Adicionar
    if(action.action === 'select-option') {
      client_cloud.mutate({
        mutation: CREATE_COMMCLIENTGROUP_HAS_ACCOUNT,
        variables: {
          clientGroup_id: action.option.value, account_id: parseInt(this.props.match.params.account_id)
        }
      });
    } 
    // Remover
    else if(action.action === 'remove-value') {
      
      client_cloud.mutate({
        mutation: DELETE_COMMCLIENTGROUP_HAS_ACCOUNT,
        variables: {
          clientGroup_id: action.removedValue.value, account_id: parseInt(this.props.match.params.account_id)
        }
      });
    }
 
  } 
  
  onChange_subclient = (inputValue, action ) => {
    
    // Adicionar
    if(action.action === 'select-option') {
      client_cloud.mutate({
        mutation: CREATE_COMMSUBCLIENT_HAS_ACCOUNT,
        variables: {
          subclient_id: action.option.value, account_id: parseInt(this.props.match.params.account_id)
        }
      });
    }
    // Remover
    else if(action.action === 'remove-value') {
      
      client_cloud.mutate({
        mutation: DELETE_COMMSUBCLIENT_HAS_ACCOUNT,
        variables: {
          subclient_id: action.removedValue.value, account_id: parseInt(this.props.match.params.account_id)
        }
      });
    }
 
  } 

  onInputChange = (inputValue, action ) => {

    
    /*
    client_cloud.mutate({
      mutation: CREATE_COMMCLIENTGROUP_HAS_ACCOUNT,
      variables: {
        account_module_id: inputValue, profile_id: this.props.match.params.account_id
      }
    });
    */
    
  }


  handleSubmit = (event) => {
    event.preventDefault();
    

  }

  render() {
    
    
    return (

      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <a
                  href='javascript:history.go(-1)'
                  className="btn btn-info btn-fill"
                >
                VOLTAR
              </a>

              <Card
                title={"Commvault"}
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={

                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();
                  }}
                  >
                  
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>

                    <Query
                        client={client_cloud}
                        query={GET_COMMCLIENTGROUP}
                      >
                        {({ loading, error, data }) => {

                          if (loading) return <tr><td>Carregando...</td></tr>;
                          if (error) return <tr><td>Erro (1)</td></tr>;

                                var select_options = data.commClientGroup_collection.clientGroups;
                               
                                return (
                        
                                <Query
                                  client={client_cloud}
                                  variables={{account_id:this.props.match.params.account_id}}
                                  query={GET_COMMCLIENTGROUP_HAS_ACCOUNT}
                                >
                                  {({ loading, error, data }) => {

                                    if (loading) return <tr><td>Carregando...</td></tr>;
                                    if (error) return <tr><td>Erro (2)</td></tr>;

                                      var defaultValues = [];
                                      data.commClientGroupHasAccount_collection.clientGroupsHasAccount.map((CommClientGroupHasAccount) => {
                                        var CommClientGroupHasAccount = CommClientGroupHasAccount.clientGroup;
                                        defaultValues.push(CommClientGroupHasAccount); 
                                      });
                                      return (
                                          <tr>
                                            <td>
                                              Grupos:
                                            </td>
                                            <td>
                                              <Select
                                                    defaultValue={this.state.defaultValue && this.state.defaultValue ? this.state.defaultValue : defaultValues}
                                                    isMulti
                                                    isSearchable
                                                    name={"values"}
                                                    options={select_options}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    //inputValue={inputValue}
                                                    onChange={this.onChange}
                                                    //onInputChange={this.onInputChange}
                                                    isClearable={false}
                                                  />
                                            </td>
                                          </tr>
                                      );
                                  }}
                                </Query>
                                );
                              }}
                            </Query>

                          <Query
                            client={client_cloud}
                            query={GET_COMMSUBCLIENT}
                          >
                            {({ loading, error, data }) => {

                              if (loading) return <tr><td>Carregando...</td></tr>;
                              if (error) return <tr><td>Erro (1)</td></tr>;

                                    var select_options = data.commSubclient_collection.subclients;
                                  
                                    return (
                            
                                    <Query
                                      client={client_cloud}
                                      variables={{account_id:this.props.match.params.account_id}}
                                      query={GET_COMMSUBCLIENT_HAS_ACCOUNT}
                                    >
                                      {({ loading, error, data }) => {

                                        if (loading) return <tr><td>Carregando...</td></tr>;
                                        if (error) return <tr><td>Erro (2)</td></tr>;

                                          var defaultValues = [];
                                          data.commSubclientHasAccount_collection.subclientsHasAccount.map((CommSubclientHasAccount) => {
                                            var CommSubclientHasAccount = CommSubclientHasAccount.subclient;
                                            defaultValues.push(CommSubclientHasAccount); 
                                          });
                                          return (
                                              <tr>
                                                <td>
                                                  Subclients:
                                                </td>
                                                <td>
                                                  <Select
                                                        defaultValue={this.state.defaultValue && this.state.defaultValue ? this.state.defaultValue : defaultValues}
                                                        isMulti
                                                        isSearchable
                                                        name={"values"}
                                                        options={select_options}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        //inputValue={inputValue}
                                                        onChange={this.onChange_subclient}
                                                        //onInputChange={this.onInputChange}
                                                        isClearable={false}
                                                      />
                                                </td>
                                              </tr>
                                          );
                                      }}
                                    </Query>
                                    );
                                  }}
                            </Query>
                          
                        <tr>
                          <td>
                          <Button bsStyle="info" pullRight fill onClick={() => {window.location.reload()}}>
                            Ver modificações
                          </Button>
                          </td>
                          <td></td>
                        </tr>
                    </tbody>
                  </Table>
                  

                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default CommClientGroupHasAccount;
